export class ID {
  public readonly id = new Int32Array(1);
  private readonly _length = 31;

  constructor(indexes?: number[]) {
    if (!indexes) return;

    for (let i = 0; i < indexes.length; i++) {
      this.setIndex(indexes[i]);
    }
  }

  /**
   * Sets an index in an id
   * @param index - index to set in the id
   */
  public setIndex(index: number) {
    this.id[0] |= 1 << (index % this._length);
  }

  /**
   * Unsets an index in an id
   * @param index - index to unset in the id
   */
  public unsetIndex(index: number) {
    this.id[0] &= ~(1 << (index % this._length));
  }

  /**
   * checks if idB contains the same bits as this id
   * @param id - id to compare
   */
  public matchIndex(id: ID): boolean {
    const q1 = this.id[0];
    const idValue = id.id;

    return ((idValue[0] & q1) ^ q1) === 0;
  }

  /**
   * checks if any bits in idB match this id
   * @param id - id to compare
   */
  public matchAnyIndex(id: ID): boolean {
    const q1 = this.id[0];
    const idValue = id.id;

    return (idValue[0] & q1) > 0;
  }
}
